export const colors = {
    inactive: "#879195",
    active: "#374247",
    filled: "#2eafbe",
} as const;
